import { ICryptoPortfolio } from './../../../../../models/Crypto';
import { Utils } from './../../../../../utils/Utils';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { curveMonotoneX } from 'd3';
import { COIN_COLOR, COIN_TICKER } from 'src/app/pages/core/models/Crypto';
import { CryptoService } from 'src/app/pages/core/abstraction/crypto.service';
import BigNumber from 'bignumber.js';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-crypto-balance',
  templateUrl: './crypto-balance.component.html',
  styleUrls: ['./crypto-balance.component.scss'],
})
export class CryptoBalanceComponent implements OnInit, OnChanges {
  @Input() balance: ICryptoPortfolio;
  @Input() equivalentInArs: boolean;
  @Input() currency: string;
  @Input() intoBundle: boolean;
  @Input() show: boolean;
  symbol: string;
  curve = curveMonotoneX;
  minMax: {
    min: number;
    max: number;
  };
  colorScheme: Color = {
    name: 'lineChartScheme',
    selectable: false,
    group: ScaleType.Ordinal,
    domain: ['#fff'],
  };
  histories;
  history: {
    name: string;
    series: {
      name: string;
      value: number;
    }[];
  }[] = [];
  variation: number;
  cryptoPrices = {};

  constructor(public cryptoService: CryptoService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.equivalentInArs) {
      this.setHistory();
    }
  }

  ngOnInit(): void {
    this.variation = +this.balance.capitalChangeP;
    this.cryptoService.cryptoHistories.subscribe((histories) => {
      if (Object.keys(histories).length !== 0) {
        this.histories = histories;
        this.setHistory();
      }
    });
    this.cryptoService.prices.subscribe((prices) => {
      this.cryptoPrices = prices;
      const currentPriceArs = prices[this.balance.ticker + '_ARS'];
      let currentPriceUsd = prices[this.balance.ticker + '_USD'];
      const stocksValue = new BigNumber(this.balance.stocks);
      if (currentPriceArs) {
        const sellPriceArs = new BigNumber(currentPriceArs.sell);
        this.balance.balanceArs = stocksValue.multipliedBy(sellPriceArs).toString();
        this.variation = +currentPriceArs.variation?.daily;
      }
      if (currentPriceUsd) {
        const sellPriceUsd = new BigNumber(currentPriceUsd.sell);
        this.balance.balance = stocksValue.multipliedBy(sellPriceUsd).toString();
        this.variation = +currentPriceUsd.variation?.daily;
      }
    });
    this.symbol = this.balance.ticker.split('_')[0].toLowerCase();
    this.colorScheme.domain[0] = COIN_COLOR[this.balance.ticker.toUpperCase()] + 'AA';
    if (!this.balance.name) {
      this.show = false;
    } else this.show = true;
  }

  getPrices(ticker) {
    if (Object.keys(this.cryptoPrices).length === 0) {
      return -1;
    }
    return this.equivalentInArs
      ? this.cryptoPrices[ticker + '_ARS']?.sell
      : this.cryptoPrices[ticker + '_USD']?.sell;
  }

  getCoinColorByCoin(coin: string) {
    return COIN_COLOR[coin];
  }

  setHistory() {
    let ticker = this.balance.ticker;
    if (ticker === 'LUNC') {
      ticker = 'LUNA';
    } else if (ticker === 'USTC') {
      ticker = 'UST';
    } else if (ticker === 'LUNA') {
      ticker = 'LUNA2';
    }
    if (this.histories) {
      this.history = this.equivalentInArs
        ? this.histories[ticker + '_ARS']
        : this.histories[ticker + '_USD'];
      this.minMax = Utils.getHistoryMinMax(this.history);
    }
  }
}
